import { CSSProperties } from 'react'

import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  itemCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
    backgroundColor: '#FFFFFF',
    borderRadius: 1.5,
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: 3
  } as SxProps,

  itemHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  } as SxProps,

  itemHeaderLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1.25
  } as SxProps,

  itemBadge: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  } as SxProps,

  itemBadgeText: {
    color: '#FFFFFF',
    fontSize: '13px',
    fontWeight: 700,
    lineHeight: 1
  } as SxProps,

  itemLabel: {
    color: theme.palette.grey[800],
    fontSize: '16px',
    fontWeight: 600
  } as SxProps,

  removeButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0.5,
    cursor: 'pointer',
    '&:hover': { opacity: 0.75 }
  } as SxProps,

  removeIcon: {
    color: '#EF4444',
    fontSize: 18
  } as SxProps,

  removeText: {
    color: '#EF4444',
    fontSize: '13px',
    fontWeight: 500
  } as SxProps,

  itemDivider: {
    height: '1px',
    backgroundColor: theme.palette.grey[100],
    width: '100%'
  } as SxProps,

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    width: '100%'
  } as SxProps,

  sectionTitle: {
    fontWeight: 600,
    fontSize: '16px',
    color: theme.palette.grey[800]
  } as SxProps,

  photoDescriptionRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2.5,
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps,

  photoUploadInput: {
    display: 'none'
  } as CSSProperties,

  photoUploadArea: {
    width: 130,
    minWidth: 130,
    minHeight: 130,
    backgroundColor: theme.palette.grey[50],
    borderRadius: 1,
    border: `1px dashed ${theme.palette.grey[300]}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    cursor: 'pointer',
    transition: 'border-color 0.2s ease',
    alignSelf: 'stretch',
    '&:hover': {
      borderColor: theme.palette.primary.main
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 'unset',
      minHeight: 200
    }
  } as SxProps,

  photoPreviewContainer: {
    position: 'relative' as const,
    width: 130,
    minWidth: 130,
    maxHeight: 130,
    objectFit: 'contain',
    alignSelf: 'stretch',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 'unset',
      minHeight: 200
    }
  } as SxProps,

  photoPreview: {
    width: '100%',
    height: '100%',
    maxHeight: 130,
    objectFit: 'cover' as const,
    borderRadius: 1,
    border: `1px solid ${theme.palette.grey[300]}`,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      minHeight: 200
    }
  } as SxProps,

  editIconOverlay: {
    position: 'absolute' as const,
    top: 8,
    right: 8,
    width: 36,
    height: 36,
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${theme.palette.grey[700]}, ${theme.palette.grey[500]})`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  } as SxProps,

  editIcon: {
    color: '#FFFFFF',
    fontSize: 18
  } as SxProps,

  uploadIcon: {
    color: theme.palette.grey[400],
    fontSize: 32
  } as SxProps,

  uploadLabel: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const
  } as SxProps,

  uploadHint: {
    color: theme.palette.grey[400],
    fontSize: '11px'
  } as SxProps,

  photoErrorText: {
    color: 'error.main',
    marginTop: 0.5,
    display: 'block'
  } as SxProps,

  descriptionWeightColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    flex: 1
  } as SxProps,

  descriptionQuantityRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps,

  descriptionField: {
    flex: 1
  } as SxProps,

  quantityField: {
    width: 100,
    minWidth: 100,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 'unset'
    }
  } as SxProps,

  valueRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps,

  declaredValueField: {
    flex: 1
  } as SxProps,

  currencyField: {
    width: 160,
    minWidth: 160,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: 'unset'
    }
  } as SxProps,

  dimensionsTitle: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.grey[800]
  } as SxProps,

  dimensionsHint: {
    display: 'block',
    color: theme.palette.grey[500],
    marginBottom: 1
  } as SxProps,

  dimensionsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps,

  formActions: {
    display: 'flex',
    gap: 2,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  } as SxProps
}

export default styles
